// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PageComponents-Publication----publication-module---container---fsoDq","title":"src-components-PageComponents-Publication----publication-module---title---iAqmr","authors":"src-components-PageComponents-Publication----publication-module---authors---3wqjv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageComponents/Publication/publication.module.css
// module id = 328
// module chunks = 96068746775097